module.exports = __webpack_public_path__ + "img/stock7.a261ea1a.png";